export { default } from './DeckGLMap'
